import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const offerSummary = (offer) =>
  [
    offer.rewardAmount != null ? `${offer.rewardCurrency || "AUD"} ${offer.rewardAmount}` : null,
    offer.targetCount ? `for ${offer.targetCount} ${offer.targetLabel || "admissions"}` : null,
    offer.deadline ? `until ${offer.deadline}` : "no end date",
  ]
    .filter(Boolean)
    .join(" ");

/**
 * The whole of one offer as the office wrote it. The published list only shows the start of each
 * description so a long one cannot stretch the page.
 */
const ProgramOfferPreviewDialog = ({ offer, onClose, onEdit }) => {
  const images = offer?.imageUrls || offer?.images || (offer?.imageUrl ? [offer.imageUrl] : []);
  return (
    <Dialog open={Boolean(offer)} onClose={onClose} scroll="paper" fullWidth maxWidth="md">
      {offer ? (
        <>
          <DialogTitle sx={{ pb: 1 }}>
            <span className="block text-base font-semibold break-words">{offer.title}</span>
            <span className="flex flex-wrap items-center gap-2 mt-1">
              <Chip size="small" label={offer.status || "ACTIVE"} />
              <span className="text-xs font-normal text-app-text-muted">{offerSummary(offer)}</span>
            </span>
          </DialogTitle>
          <DialogContent dividers>
            {images.length ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                {images.map((url) => (
                  <img
                    key={url}
                    src={url}
                    alt=""
                    className="w-full rounded-lg border border-app-border object-cover"
                  />
                ))}
              </div>
            ) : null}
            <p className="text-sm m-0 whitespace-pre-line break-words leading-relaxed">
              {offer.description || offer.body || "No description."}
            </p>
          </DialogContent>
          <DialogActions>
            {onEdit ? <Button onClick={() => onEdit(offer)}>Edit</Button> : null}
            <Button variant="contained" onClick={onClose}>
              Close
            </Button>
          </DialogActions>
        </>
      ) : null}
    </Dialog>
  );
};

export default ProgramOfferPreviewDialog;
